import React, { useEffect, useState } from "react";
import { navigate } from "@reach/router";
import AuthService from "../services/AuthService";
import { useSnackbar } from "notistack";
import { getErrorMessage } from "../helpers/functions";

export const ViewerContext = React.createContext();

function ViewerProvider({ children }) {
  const [token, setToken] = useState(null);
  const [userObject, setUserObject] = useState({});
  const [password, setPassword] = useState(null);
  const [role, setRole] = useState(null);
  const [data, setData] = useState();
  const { enqueueSnackbar } = useSnackbar();
  const [globalState, setGlobalState] = useState();

  useEffect(() => {
    try {
      function getToken() {
        try {
          const local_token = localStorage.getItem("auth_token");
          const local_token_password = localStorage.getItem("change-password");
          if (local_token) setToken(local_token);
          if (local_token_password) setPassword(local_token_password);
        } catch (error) {
          console.log(error);
        }
      }
      getToken();
    } catch (error) {
      console.log(error);
    }
  }, []);

  useEffect(() => {
    async function fetchUserProfile() {
      try {
        const user = await AuthService.profile();
        if (user?.me) {
          setUserObject(user.me);
          setRole(user?.role);
        }
      } catch (error) {
        const message = getErrorMessage(error);
        enqueueSnackbar(message, {
          variant: "error",
        });
      }
    }
    try {
      if (token) {
        if (token === "logged_out") {
          localStorage.setItem("auth_token", "");
          localStorage.removeItem("image");
          console.log("viewer provider", role);
          navigate("/");
          setUserObject({});
          setToken(null);
          setGlobalState();
        } else {
          localStorage.setItem("auth_token", token);
          fetchUserProfile();
        }
      }
    } catch (error) {
      console.log(error);
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, password]);

  const value = React.useMemo(() => {
    return {
      token,
      setToken,
      userObject,
      setUserObject,
      password,
      setPassword,
      role,
      setRole,
      data,
      setData,
      globalState,
      setGlobalState,
    };
  }, [
    token,
    setToken,
    userObject,
    setUserObject,
    password,
    setPassword,
    role,
    setRole,
    data,
    setData,
    globalState,
    setGlobalState,
  ]);

  return (
    <ViewerContext.Provider value={value}>{children}</ViewerContext.Provider>
  );
}

export default ViewerProvider;
